import { CSSProperties, SVGProps } from 'react'

const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    x={0}
    y={0}
    style={
      {
        enableBackground: 'new 0 0 60 60'
      } as CSSProperties
    }
    viewBox="0 0 60 60"
    {...props}
  >
    <style>{'.st0{fill:#13142b}'}</style>
    <path
      d="M37.8 22.9 27.6 33.1l-4.4-4.4c-.8-.8-2-.8-2.7 0-.8.8-.8 2 0 2.7l5.8 5.8c.8.8 2 .8 2.7 0l11.6-11.6c.8-.8.8-2 0-2.7-.8-.8-2.1-.8-2.8 0z"
      className="st0"
    />
    <path
      d="M30.5 8.8C18.8 8.8 9.3 18.3 9.3 30s9.5 21.2 21.2 21.2S51.7 41.7 51.7 30 42.2 8.8 30.5 8.8zm0 38.6c-9.6 0-17.4-7.8-17.4-17.4s7.8-17.4 17.4-17.4S47.9 20.4 47.9 30s-7.8 17.4-17.4 17.4z"
      className="st0"
    />
  </svg>
)
export default Check
